import { GetDeviceSnapshotDTO, UnitStateV2 } from '@eppendorf/vnls-device-service-utils';

import { ConnectionStatusBadge } from '$features/devices/connection-status-badge';
import { ActivityStatusSnapshot } from '$features/monitoring/activity-status/activity-status-snapshot';

interface DeviceStatusSnapshotProps {
  deviceSnapshot?: GetDeviceSnapshotDTO;
  bordered?: boolean;
}

export function DeviceStatusSnapshot({
  deviceSnapshot,
  bordered = false,
}: DeviceStatusSnapshotProps) {
  return deviceSnapshot?.currentShadow?.activityState === UnitStateV2.Offline ? (
    <ActivityStatusSnapshot
      activityStatus={deviceSnapshot.currentShadow.activityState}
      bordered={bordered}
      offlineSince={
        deviceSnapshot.currentShadow.lastSeenAt ??
        deviceSnapshot.currentShadow.shadowUpdatedAt ??
        undefined
      }
    />
  ) : (
    <ConnectionStatusBadge
      status={deviceSnapshot?.inventoryDevice?.connectionStatus}
      bordered={bordered}
    />
  );
}
